export const fakePortalConfig = {
    "data": {
      "enableAutoProvision": true
  }
}